import { combineReducers } from "redux";
import user from "store/user/user.reducer";
import patient from "store/patient/patient.reducer";

export default combineReducers({
    user,
    patient,
});
